/**
 * Created by gilk on 08/08/17.
 */
define(function (require) {
    "use strict";
    var LE = require("app");
    var template = require("user-management-templates/skills/accountSettingsSLAOptionView.tmpl");
    var AccountSettingsSLAOptionBubbleView = require("user-management-views/skills/AccountSettingsSLAOptionBubbleView");
    var Bubble = require("ui/bubble/Bubble");

    var AccountSettingsSLAOptionView = {};

    LE.module("LEUserManagement", function (LEUserManagement, LE, Backbone, Marionette, $, _) {
        AccountSettingsSLAOptionView = Marionette.ItemView.extend({
            template : template,
            className: "sla-account-settings-container",
            ui: {
                accountSettingsIcon: ".account-settings-icon"
            },
            uiComponents: {

            },
            events: {
                "mouseenter @ui.accountSettingsIcon": "_showAccountSettingsBubble",
                "mouseleave @ui.accountSettingsIcon": "_closeAccountSettingsBubble"
            },

            _showAccountSettingsBubble: function() {
                this._closeAccountSettingsBubble(null, true);
                this.uiComponents.host$.createAndRender("accountSettingsBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.accountSettingsIcon,
                        position: Bubble.POSITION.RIGHT,
                        showCloseButton: false,
                        isDelayed: true,
                        contentView: new AccountSettingsSLAOptionBubbleView()
                    }
                });
            },

            _closeAccountSettingsBubble: function(event, force) {
                if (_.has(this.uiComponents, "accountSettingsBubble")) {
                    this.uiComponents.accountSettingsBubble.close(force);
                }
            },

            onClose: function() {
                LEUserManagement.logger.debug("onClose", "AccountSettingsSLAOptionView:onClose");
            }
        });
    });

    return AccountSettingsSLAOptionView;
});
